import { StepProps, Steps, StepsProps } from 'antd';

interface RegistrationStepsProps {
  current: number;
  stepsProps?: StepsProps;
}

export const stepConfig: StepProps[] = [
  {
    title: 'Create your account'
  },
  {
    title: 'Create your organization'
  },
  {
    title: 'Initialise organisation (Automatic)'
  },
  {
    title: 'Finished'
  }
];
export default function RegistrationSteps(props: RegistrationStepsProps) {
  return (
    <Steps
      current={props.current}
      style={{ marginBottom: '20px' }}
      items={stepConfig}
      {...props.stepsProps}
    />
  );
}
